import React from 'react';
import ReactPlayer from 'react-player/facebook';
import {makeStyles} from '@material-ui/core/styles';
import {
    Box,
    Grid,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardMedia,
    Button,
    Typography
} from '@material-ui/core'
import virtuous from '../images/IMG_0908.jpg'
import kwame from '../images/IMG_0937.jpg'
import wedding from '../images/wedding.png'

const useStyles = makeStyles(theme =>({
    mainContainer: {
        background: "#233",
        // height: "100%",
        minHeight: "100vh",
        marginTop: "50px",
    },
    cardContainer: {
        maxWidth: 345,
        margin: "5rem auto",
        [theme.breakpoints.down("sm")]:{
            maxWidth: "80%"
        }
    }
}))

const Events = () => {
    const classes = useStyles()
    return (
        <Box component="div" className={classes.mainContainer}>
            {/* <Navbar/> */}
            <Grid container justify="center">
                {/* project1 */}
                <Grid item xs={12} sm={8} md={6}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                height="150"
                            >
                                <ReactPlayer
                                    className={classes.react_player} 
                                    url='https://fb.watch/dEeyHbS54m/'
                                    width='100%'
                                    height='100%'
                                />
                            </CardMedia>
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    #SAMJUST WEDDING
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    We Capture Nostalgic Moments and Events 
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary">
                                    Share
                                </Button>
                                <Button size="small" color="primary" href="https://fb.watch/dEe6iaDQJc/" target="_blank">
                                    View
                                </Button>
                            </CardActions>
                        </CardActionArea>
                    </Card>
                </Grid>

                {/* project2 */}
                <Grid item xs={12} sm={8} md={6}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                height="150"
                            >
                                <CardMedia
                                    component="img"
                                    alt="Project 1"
                                    height="150"
                                    image={kwame}
                                />
                            </CardMedia>
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    #WEDDING BELLS
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    We Capture Nostalgic Moments and Events 
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary">
                                    Share
                                </Button>
                                <Button size="small" color="primary" href="https://fb.watch/dEePpfY3_0/" target="_blank">
                                    View
                                </Button>
                            </CardActions>
                        </CardActionArea>
                    </Card>
                </Grid>

                {/* project3 */}
                <Grid item xs={12} sm={8} md={6}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                height="150"
                            >
                                <CardMedia
                                    component="img"
                                    alt="Project 1"
                                    height="150"
                                    image={wedding}
                                />
                            </CardMedia>
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    #WEDDING BELLS
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    We Capture Nostalgic Moments and Events 
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary">
                                    Share
                                </Button>
                                <Button size="small" color="primary" href="https://www.facebook.com/AblekumaCentralC.O.P/videos/287676362826571/" target="_blank">
                                    View
                                </Button>
                            </CardActions>
                        </CardActionArea>
                    </Card>
                </Grid>

                {/* project2 */}
                <Grid item xs={12} sm={8} md={6}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                height="150"
                            >
                                <ReactPlayer
                                    className={classes.react_player} 
                                    url='https://fb.watch/dEdvChvZdq/'
                                    width='100%'
                                    height='100%'
                                />
                            </CardMedia>
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    #DISTRICT WEEK
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    CHURCH CONVENTION
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary">
                                    Share
                                </Button>
                                <Button size="small" color="primary" href="https://fb.watch/dEdvChvZdq/" target="_blank">
                                    Like Page
                                </Button>
                            </CardActions>
                        </CardActionArea>
                    </Card>
                </Grid>

                {/* project2 */}
                <Grid item xs={12} sm={8} md={6}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                alt="Project 1"
                                height="150"
                                image={virtuous}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    #VIRTUOUS LADIES WEEK
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    LAUNCHING OF VIRTUOUS LADIES
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary">
                                    Share
                                </Button>
                                <Button size="small" color="primary" href="https://fb.watch/dEfjn4Y8gd/" target="_blank">
                                    View
                                </Button>
                            </CardActions>
                        </CardActionArea>
                    </Card>
                </Grid>

                {/* project2 */}
                <Grid item xs={12} sm={8} md={6}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                height="150"
                            >
                                <ReactPlayer
                                    className={classes.react_player} 
                                    url='https://fb.watch/j0ZqZI0OPJ/'
                                    width='100%'
                                    height='100%'
                                />
                            </CardMedia>
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    #AYEYI FESTIVAL
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    A YEARLY YOUTH PRAISE NIGHT
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary">
                                    Share
                                </Button>
                                <Button size="small" color="primary" href="https://fb.watch/j0ZqZI0OPJ/" target="_blank">
                                    View
                                </Button>
                            </CardActions>
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Events
